import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useProfile } from '../../user/context/ProfileContext';
import Logout from './Logout';

const Menu = ({ hideMenue = false, onClose, isAuthenticated }) => {
    const location = useLocation();
    const { userInfo } = useProfile();

    const isActive = (path) => (location.pathname === path ? 'active' : '');

    const getInitials = (name) => {
        if (!name) return 'U';
        const parts = name.trim().split(' ');
        return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
    };

    return (
        <div className="as_menu">
            {/* Profile Section (only for mobile slider) */}
            {hideMenue && (
                // <div className="menu_profile">
                    <Link
                        to={isAuthenticated ? '/profile' : '/login'}
                        className="menu_profile"
                        onClick={onClose}
                    >
                        {isAuthenticated ? (
                            userInfo?.full_profile_pic &&
                            !userInfo.full_profile_pic.includes('default-profile_pic') ? (
                                <img
                                    src={userInfo.full_profile_pic}
                                    alt={userInfo?.name || 'Profile'}
                                    className="profile_image"
                                />
                            ) : (
                                <div className="profile_initials">{getInitials(userInfo?.name)}</div>
                            )
                        ) : (
                            <div className="profile_initials">
                                <i className="fas fa-user" />
                            </div>
                        )}

                        <div className="profile_info">
                            <h3>{isAuthenticated ? userInfo?.name || 'User' : 'Guest User'}</h3>
                            <p>
                                {isAuthenticated
                                    ? userInfo?.mobile || userInfo?.contact_number || 'Contact not available'
                                    : 'Tap to login'}
                            </p>
                        </div>
                    </Link>
                // </div>
            )}
            {/* Menu Items */}
            <ul>
                <li>
                    <Link className={isActive('/')} to="/" onClick={onClose}>
                        <i className="fas fa-home me-2"></i> Home
                    </Link>
                </li>
                <li>
                    <Link className={isActive('/astrologer')} to="/astrologer">
                        <i className="fas fa-comments me-2"></i> Chat with Astrologers
                    </Link>
                </li>
                <li>
                    <Link className={isActive('/free-kundli')} to="/free-kundli">
                        <i className="fas fa-book-open me-2"></i> Free Kundli
                    </Link>
                </li>
                <li>
                    <Link className={isActive('/horoscope/:aries')} to="/horoscope/aries">
                        <i className="fas fa-star me-2"></i> Horoscope
                    </Link>
                </li>
                <li>
                    <Link className={isActive('/blogs')} to="/blogs">
                        <i className="fas fa-blog me-2"></i> Blog
                    </Link>
                </li>
                <li>
                    <Link className={isActive('/categories')} to="/categories">
                        <i className="fas fa-store me-2"></i> Astroscope Store
                    </Link>
                </li>
                <li>
                    <Link className={isActive('/contactus')} to="/contactus">
                        <i className="fas fa-envelope me-2"></i> Contact Us
                    </Link>
                </li>
                {hideMenue && (
                    <>
                        {isAuthenticated ? (
                            <li>
                                <div onClick={onClose}>
                                    <i className="fas fa-sign-out-alt me-2"></i>
                                    <Logout />
                                </div>
                            </li>
                        ) : (
                            <li>
                                <Link to="/login" onClick={onClose}>
                                    <i className="fas fa-sign-in-alt me-2"></i>
                                    Login
                                </Link>
                            </li>
                        )}
                    </>
                )}
            </ul>
        </div>
    );
};

export default Menu;
